const addedToSearchBox = props => ({
    value: props.controller,
    type: "ADD_TO_SEARCHBOX"
});
const addedToSearchBoxAff = props => ({
    value: props.controller,
    type: "ADD_TO_SEARCHBOX_AFF"
});
const addedDidYouMeanToSearchBox = props => ({
    value: props.stateDidYouMean,
    type: "ADD_DID_YOU_MEAN_TO_SEARCHBOX"
});

const toggleAutosuggestion = props => ({
    value: props,
    type: "TOGGLE_AUTOSUGGESTION"
});
const setEmptySuggestions = props => ({
    value: props,
    type: "SET_EMPTY_SUGGESTIONS"
});
const setPageUrl = props => ({
    value: props,
    type: "SET_PAGE_URL"
});
const setActivePill = props => ({
    value: props,
    type: "SET_ACTIVE_PILL"
});
const setActiveActionSearchBox = props => ({
    value: props,
    type: "SET_ACTIVE_ACTION_SEARCHBOX"
});
const setActiveActionFilter = props => ({
    value: props,
    type: "SET_ACTIVE_ACTION_FILTER"
});
const setSearchActionClearFilter = props => ({
    value: props,
    type: "SET_SEARCH_ACTION_CLEAR_FILTER"
});
const setContentQuickView = props => ({
    title: props.title,
    value: props.contentQuickView,
    valueToggleModal: props.toggleModalQuickView,
    clickUrl: props.clickUrl,
    type: "SET_CONTENT_QUICK_VIEW"
});
const setToggleModalQuickView = props => ({
    valueToggleModal: props.toggleModalQuickView,
    type: "SET_TOGGLE_MODAL_QUICK_VIEW"
});
const setActiveDidYouMean = props => ({
    value: props.isActiveDidYouMean,
    type: "SET_ACTIVE_DID_YOU_MEAN"
});
const setActiveClearValueInputPrice = props => ({
    value: props.value,
    type: "SET_ACTIVE_CLEAR_VALUE_INPUT_PRICE"
});
const setActiveFilterSearchBox = props => ({
    value: props.value,
    type: "SET_ACTIVE_FILTER_SEARCH_BOX"
});
const setActiveOKB = props => ({
    value: props.value,
    type: "SET_ACTIVE_OKB"
});
const setActiveSalesforce = props => ({
    value: props.value,
    type: "SET_ACTIVE_SALESFORCE"
});
const setActiveINET =  props => ({
    value: props.value,
    type: "SET_ACTIVE_INET"
});
const setIsShowRecommendedForModel =  props => ({
    value: props.value,
    type: "IS_SHOW_RECOMMENDED_INET"
});
const setDidYouMeanForSupportSearch = props => ({
    value: props.value,
    type: "SET_DID_YOU_MEAN_FOR_SUPPORT_SEARCH"
});
const setFirstSearchIsNoResult = props => ({
    value: props,
    type: "IS_NO_RESULT"
});
const setMostPopularResult = props => ({
    value: props,
    type: "IS_NO_MOST_POPULAR"
});

const setIsNoResultByFilterPrice = props => ({
    value: props,
    type: "IS_NO_RESULT_BY_INPUT_PRICE"
});
const setDataModalInet = props => ({
    value: props,
    type: "DATA_MODAL_INET"
});
const setActiveSortState = props => ({
    value: props.value,
    type: "SET_ACTIVE_SORT"
});
const setCurrentSortState = props => ({
    value: props.value,
    type: "SET_CURRENT_SORT"
});
export {setActiveSortState, setCurrentSortState, setActiveSalesforce, setIsNoResultByFilterPrice, setFirstSearchIsNoResult , addedToSearchBoxAff, setDidYouMeanForSupportSearch , setActiveOKB , setActiveINET, setDataModalInet, setIsShowRecommendedForModel, setActiveFilterSearchBox,setActiveClearValueInputPrice ,setActiveDidYouMean , setToggleModalQuickView , setContentQuickView , setSearchActionClearFilter , addedDidYouMeanToSearchBox, addedToSearchBox, toggleAutosuggestion, setEmptySuggestions, setPageUrl , setActivePill ,setActiveActionSearchBox , setActiveActionFilter, setMostPopularResult};